import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { getPostPath, getValidCategoryNames } from '../../../model/post';
import { Episodes } from '../../articles/single/documentary';
import { Section } from '../index';
import PlayIcon from "../../../assets/svgs/icon-play.svg";

const Documentary = ({
  issue,
  lazyLoad,
}) => {
  const { name: articleType, posts } = issue;

  const {
    title,
    slug,
    featuredImage,
    categories: { nodes: categories },
    tghpwipDocumentarySubtitle: documentarySubtitle,
    tghpwipDocumentaryEpisodes: documentaryEpisodes,
  } = posts.nodes[0];

  const validCategories = getValidCategoryNames(categories);
  const categorySlug = categories[0]?.slug;
  const postImage = featuredImage?.node;

  const defaultEpisodeIndex = documentaryEpisodes.length - 1;
  const [currentEpisode, setCurrentEpisode] = useState(defaultEpisodeIndex);
  const [episodeTitle, setEpisodeTitle] = useState(
    documentaryEpisodes[defaultEpisodeIndex]?.documentaryEpisodesTitle,
  );
  const [episodeVideoCode, setEpisodeVideoCode] = useState(
    documentaryEpisodes[defaultEpisodeIndex]?.documentaryEpisodesVideo,
  );

  const onChangeEpisode = (episodeNum) => {
    setCurrentEpisode(episodeNum);
  };

  useEffect(() => {
    setEpisodeTitle(documentaryEpisodes[currentEpisode]?.documentaryEpisodesTitle);
    setEpisodeVideoCode(documentaryEpisodes[currentEpisode]?.documentaryEpisodesVideo);
  }, [currentEpisode, documentaryEpisodes]);

  const linkProps = {
    to: getPostPath(slug),
  };

  const linkWithEpisodeProps = {
    ...linkProps,
    state: {
      currentEpisode,
      videoCode: episodeVideoCode,
    },
  };

  return (
    <Section
      type="documentary"
      issue={issue}
      color={categorySlug ? categorySlug : `black`}
      expandButtonLocation={false}
    >
      <Link
        position="beforeRestPosts"
        {...linkWithEpisodeProps}
        className="documentary-issue-grid__image"
      >
        {postImage && (
          <>
            <img
              src={postImage.publicUrl}
              srcSet={postImage.srcSet}
              alt={postImage.altText}
              sizes="100vw"
              loading={lazyLoad ? 'lazy' : 'eager'}
            />
            <div className="documentary-issue-grid__image-play-icon">
              <PlayIcon />
            </div>
          </>
        )}
      </Link>
      <div position="beforeRestPosts" className="documentary-issue-grid__intro intro-titles">
        <div className="intro-titles__label">Film</div>
        {validCategories.length > 0 && <div className="intro-titles__name">{articleType}</div>}
      </div>
      <div position="beforeRestPosts" className="documentary-issue-grid__content">
        <div className="documentary-issue-grid__head">
          <Link {...linkProps} className="documentary-issue-grid__head-title">
            {title}
          </Link>
          <div className="documentary-issue-grid__head-subtitle">{documentarySubtitle}</div>
          <div className="documentary-issue-grid__head-episode-title">
            <span>
              {episodeTitle &&
                `${
                  documentaryEpisodes.length > 1 ? `Ep. ${currentEpisode + 1} - ` : ''
                }${episodeTitle}`}
            </span>
            <span>{episodeTitle}</span>
          </div>
          <Link {...linkWithEpisodeProps} className="documentary-issue-grid__head-button">
            <span>Watch now</span>
            <span>Watch →</span>
          </Link>
        </div>
        <div className="documentary-issue-grid__episodes documentary-episodes">
          {documentaryEpisodes.length > 1 && (
            <Episodes
              episodes={documentaryEpisodes}
              onChangeEpisode={onChangeEpisode}
              currentEpisode={currentEpisode}
            />
          )}
        </div>
      </div>
      <Link {...linkWithEpisodeProps} className="documentary-issue-grid__mobile-watch-button">
        Watch now
      </Link>
    </Section>
  );
};

export default Documentary;
